import type {
  EventoStatus,
  MetodoPagamento,
  ParticipanteEvento,
  StatusInscricao,
  StatusPagamento,
} from './types'

export type EventoStatusKey = Exclude<EventoStatus, null>

export const STATUS_INSCRICAO_LABEL: Record<StatusInscricao, string> = {
  confirmado: 'Confirmado',
  pendente: 'Pendente',
  cancelado: 'Cancelado',
}

export const STATUS_INSCRICAO_BADGE: Record<StatusInscricao, string> = {
  confirmado: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-200',
  pendente: 'bg-amber-100 text-amber-700 dark:bg-amber-500/10 dark:text-amber-200',
  cancelado: 'bg-rose-100 text-rose-700 dark:bg-rose-500/10 dark:text-rose-200',
}

export const STATUS_PAGAMENTO_LABEL: Record<StatusPagamento, string> = {
  pago: 'Pago',
  pendente: 'Pendente',
  isento: 'Isento',
  parcial: 'Parcial',
}

export const STATUS_PAGAMENTO_BADGE: Record<StatusPagamento, string> = {
  pago: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-200',
  pendente: 'bg-amber-100 text-amber-700 dark:bg-amber-500/10 dark:text-amber-200',
  isento: 'bg-blue-100 text-blue-700 dark:bg-blue-500/10 dark:text-blue-200',
  parcial: 'bg-orange-100 text-orange-700 dark:bg-orange-500/10 dark:text-orange-200',
}

export const METODO_PAGAMENTO_LABEL: Record<MetodoPagamento, string> = {
  pix: 'Pix',
  dinheiro: 'Dinheiro',
  cartao: 'Cartão',
}

export const EVENTO_STATUS_LABEL: Record<EventoStatusKey, string> = {
  rascunho: 'Rascunho',
  programado: 'Programado',
  confirmado: 'Confirmado',
  publicado: 'Publicado',
  adiado: 'Adiado',
  cancelado: 'Cancelado',
}

export const EVENTO_STATUS_BADGE: Record<EventoStatusKey, string> = {
  rascunho: 'bg-slate-100 text-slate-700 dark:bg-slate-500/10 dark:text-slate-200',
  programado: 'bg-blue-100 text-blue-700 dark:bg-blue-500/10 dark:text-blue-200',
  confirmado: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-200',
  publicado: 'bg-green-100 text-green-700 dark:bg-green-500/10 dark:text-green-200',
  adiado: 'bg-amber-100 text-amber-700 dark:bg-amber-500/10 dark:text-amber-200',
  cancelado: 'bg-rose-100 text-rose-700 dark:bg-rose-500/10 dark:text-rose-200',
}

export const DEFAULT_PARTICIPANTES: ParticipanteEvento[] = [
  {
    id: 'p-1',
    nome: 'Ana Souza',
    email: 'ana.souza@example.com',
    telefone: '(11) 98888-1122',
    funcoes: ['Membro'],
    status: 'confirmado',
    pagamento: {
      status: 'pago',
      metodo: 'pix',
      valor: 50,
      pagoEm: '2024-11-12T14:20:00Z',
    },
    checkIn: {
      status: 'realizado',
      horario: '2024-11-24T18:45:00Z',
    },
    comprovanteUrl: 'https://example.com/comprovante.pdf',
  },
  {
    id: 'p-2',
    nome: 'Bruno Oliveira',
    email: 'bruno.oliveira@example.com',
    telefone: '(11) 97777-3344',
    funcoes: ['Visitante'],
    status: 'pendente',
    pagamento: {
      status: 'pendente',
      metodo: 'cartao',
      valor: 50,
    },
    checkIn: {
      status: 'pendente',
    },
  },
  {
    id: 'p-3',
    nome: 'Carla Nascimento',
    email: 'carla.nascimento@example.com',
    telefone: '(11) 96666-5566',
    funcoes: ['Voluntária'],
    status: 'confirmado',
    pagamento: {
      status: 'pago',
      metodo: 'dinheiro',
      valor: 50,
      pagoEm: '2024-11-18T19:10:00Z',
    },
    checkIn: {
      status: 'pendente',
    },
  },
  {
    id: 'p-4',
    nome: 'Diego Santos',
    email: 'diego.santos@example.com',
    telefone: '(11) 95555-7788',
    funcoes: ['Membro'],
    status: 'confirmado',
    pagamento: {
      status: 'pago',
      metodo: 'pix',
      valor: 50,
      pagoEm: '2024-11-19T10:05:00Z',
    },
    checkIn: {
      status: 'realizado',
      horario: '2024-11-24T18:55:00Z',
    },
  },
  {
    id: 'p-5',
    nome: 'Eduarda Lima',
    email: 'eduarda.lima@example.com',
    telefone: '(11) 94444-9900',
    funcoes: ['Equipe de Recepção'],
    status: 'cancelado',
    pagamento: {
      status: 'isento',
      valor: 0,
    },
    checkIn: {
      status: 'pendente',
    },
  },
]

export const PARTICIPANTES_POR_EVENTO: Record<string, ParticipanteEvento[]> = {
  '1': DEFAULT_PARTICIPANTES,
  '2': [
    {
      id: 'c-1',
      nome: 'Fernanda Dias',
      email: 'fernanda.dias@example.com',
      telefone: '(11) 98765-4321',
      funcoes: ['Líder da Célula'],
      status: 'confirmado',
      pagamento: {
        status: 'pago',
        metodo: 'pix',
        valor: 0,
        pagoEm: '2024-11-05T12:00:00Z',
      },
      checkIn: {
        status: 'pendente',
      },
    },
    {
      id: 'c-2',
      nome: 'Gabriel Martins',
      email: 'gabriel.martins@example.com',
      telefone: '(11) 91234-5678',
      funcoes: ['Membro'],
      status: 'confirmado',
      pagamento: {
        status: 'isento',
        valor: 0,
      },
      checkIn: {
        status: 'pendente',
      },
    },
    {
      id: 'c-3',
      nome: 'Helena Castro',
      email: 'helena.castro@example.com',
      telefone: '(11) 99876-5432',
      funcoes: ['Membro'],
      status: 'pendente',
      pagamento: {
        status: 'pendente',
        valor: 0,
      },
      checkIn: {
        status: 'pendente',
      },
    },
    {
      id: 'c-4',
      nome: 'Igor Figueiredo',
      email: 'igor.figueiredo@example.com',
      telefone: '(11) 93333-2211',
      funcoes: ['Visitante'],
      status: 'cancelado',
      pagamento: {
        status: 'isento',
        valor: 0,
      },
      checkIn: {
        status: 'pendente',
      },
    },
  ],
  '3': [
    {
      id: 'r-1',
      nome: 'João Ferreira',
      email: 'joao.ferreira@example.com',
      telefone: '(11) 91111-2233',
      funcoes: ['Membro'],
      status: 'confirmado',
      pagamento: {
        status: 'pago',
        metodo: 'cartao',
        valor: 350,
        pagoEm: '2024-11-01T09:30:00Z',
      },
      checkIn: {
        status: 'pendente',
      },
    },
    {
      id: 'r-2',
      nome: 'Larissa Pires',
      email: 'larissa.pires@example.com',
      telefone: '(11) 93210-9876',
      funcoes: ['Intercessora'],
      status: 'pendente',
      pagamento: {
        status: 'pendente',
        metodo: 'pix',
        valor: 350,
      },
      checkIn: {
        status: 'pendente',
      },
    },
    {
      id: 'r-3',
      nome: 'Marcelo Guedes',
      email: 'marcelo.guedes@example.com',
      telefone: '(11) 98812-3456',
      funcoes: ['Equipe de Apoio'],
      status: 'confirmado',
      pagamento: {
        status: 'pago',
        metodo: 'dinheiro',
        valor: 350,
        pagoEm: '2024-11-03T14:15:00Z',
      },
      checkIn: {
        status: 'pendente',
      },
    },
    {
      id: 'r-4',
      nome: 'Natália Barros',
      email: 'natalia.barros@example.com',
      telefone: '(11) 99777-8899',
      funcoes: ['Visitante'],
      status: 'cancelado',
      pagamento: {
        status: 'isento',
        valor: 0,
      },
      checkIn: {
        status: 'pendente',
      },
    },
  ],
}
